export default Object.freeze({
  EMAIL: 1,
  SMS: 8,
  CALL: 10,
})
